// extracted by mini-css-extract-plugin
export var btnFacebook = "component-module--btn-facebook--98a49";
export var btnLinkedin = "component-module--btn-linkedin--8c21b";
export var btnWechat = "component-module--btn-wechat--38c57";
export var btnXing = "component-module--btn-xing--1c99e";
export var btnYoutube = "component-module--btn-youtube--9c1cd";
export var container = "component-module--container--12503";
export var downloadBtn = "component-module--downloadBtn--35795";
export var icon = "component-module--icon--4bf93";
export var iconPdf = "component-module--iconPdf--12179";
export var iconText = "component-module--icon-text--943b3";
export var iconZip = "component-module--iconZip--4e2d8";
export var list = "component-module--list--1498d";
export var mail = "component-module--mail--25e74";
export var phone = "component-module--phone--6e65e";
export var printer = "component-module--printer--e0992";